import React from "react";
import "../App.css";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import swal from "sweetalert";
import { AddAttachment, DownloadAttachment } from "../Actions/AttachmentAPI";
import Moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  putUpdateService,
  postUpdateServiceImages,
} from "../Actions/ServiceUpdateAPI";
import API from "../helpers/api";
import axios from "axios";
import * as moment from "moment";
import {
  getEquipmentServiceTypeList,
  uploadAttachments,
  deleteAttachmentInBucket,
} from "../Actions/CommonAPI";
//import { getEquipmentServiceUpdateTypeList } from "../Actions/EquipmentManagementAPI";
import {
  getPortAndCountry,
  getShipPortAndCountry,
} from "../Actions/ServiceProviderAPI";
import { getServiceDates } from "../Actions/helpersAPI";
// import { getServiceImages } from "../Actions/ApproverScreenAPI";
import Autocomplete from "react-autocomplete";
import { Multiselect } from "multiselect-react-dropdown";
// import { postUpdateServiceImages } from "../Actions/ServiceUpdateAPI";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";
import Role from "../helpers/role";
import { presets } from "glamor";
import { ThreeSixty } from "@material-ui/icons";

toast.configure();

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let userroles = localStorage.getItem("UserRoles");
var fileDatas = [];
class EquipmentUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      OverDueService: false,
      openAlert: false,
      SelectedFromDate: "",
      NextDue: "",
      fromDatePickerIsOpen: false,
      nextDueDatePickerIsOpen: false,
      id: "",
      FileUploadstatus: true,
      serviceUpdate: {
        shipId: 0,
        shipEquipmentId: "",
        equipmentServiceId: 0,
        serviceType: "",
        serviceDate: "",
        nextDueIn: "",
        lastDonePort: "",
        lastDoneCountry: "",
        lastDoneServiceProvider: "",
        attachmentName: "",
        attachmentGuid: "",
        remarks: "",
        modifiedBy: "",
        requestedBy: "",
        portId: 0,
        servicePhoto: [],
        attachService: [],
        isAdmin: false,
        servicedQty: "",
        mmplPrice: 0,
        vendorPrice: 0,
        zoneId: 0,
      },
      remarks: "",
      isApproved: true,
      docfile: "",
      openPort: false,
      openCountry: false,
      openServiceProvider: false,
      ServiceImages: [],
      SelectedServiceYear: [],
      SelectedOverdueServiceYear: [],
      zoneList: [],
    };

    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleNextDue = this.handleNextDue.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openNextDueDatePicker = this.openNextDueDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderPortTitle = this.renderPortTitle.bind(this);
    this.renderCountryTitle = this.renderCountryTitle.bind(this);
    this.renderServiceProviderTitle =
      this.renderServiceProviderTitle.bind(this);
  }

  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    };
  }
  componentWillUnmount() {
    this.props.dispatch({
      type: "AttchmentUploaded",
      data: undefined,
    });
  }
  componentDidMount() {
    const { dispatch, serviceDetail } = this.props;
    let data = {
      port: "",
      country: "",
      serviceProvider: "",
    };
    this.setState({});
    console.log(serviceDetail, "serviceDetail");
    console.log("DATA", this.state.serviceUpdate);
    this.getZoneList();
    dispatch(getShipPortAndCountry(data));
    /*  dispatch(
      getEquipmentServiceUpdateTypeList(
        serviceDetail.shipId,
        serviceDetail.shipEquipmentId,
        serviceDetail.equipmentServiceId
      )
    ); */
    console.log(
      "ShipIds",
      serviceDetail.shipId,
      serviceDetail.shipEquipmentId,
      serviceDetail.equipmentServiceId
    );
    dispatch(
      getServiceDates(
        Moment(new Date(serviceDetail.serviceDate)).format("YYYY-MM-DD"),
        serviceDetail.interval
      )
    );

    // if (serviceDetail.previousEquipmentServiceId !== 0) {
    //   dispatch(getServiceImages(serviceDetail.previousEquipmentServiceId));
    // } else {
    //   dispatch(getServiceImages(serviceDetail.equipmentServiceId));

    // }
  }

  getZoneList = () => {
    let url1 = `${API.getFullZoneList}`;
    axios
      .get(url1)
      .then((response) => {
        this.setState({ zoneList: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // componentWillUnmount() {
  //   window.onpopstate = () => window.history.forward();

  // }
  static getDerivedStateFromProps(nextProps, prevState) {
    // window.onpopstate = () => window.history.forward();
    const {
      dispatch,
      attachmentDetail,
      serviceDetail,
      ServiceDate,
      serviceAttachment,
    } = nextProps;
    // prevState.serviceUpdate = nextProps.serviceDetail;
    //   {
    //     "shipId": 131,
    //     "shipEquipmentId": 1797,
    //     "equipmentId": 214,
    //     "portId": 65,
    //     "serviceProviderId": 70,
    //     "equipmentServiceId": 2719,
    //     "previousEquipmentServiceId": 0,
    //     "serviceAttachmentId": 23287,
    //     "interval": 1,
    //     "equipmentName": "15 PPM Bilge Alarm Device",
    //     "isOwner": false,
    //     "isShip": false,
    //     "isShore": true,
    //     "serviceTypeId": 21,
    //     "serviceType": "1 yearly",
    //     "serviceDate": "2024-08-03T00:00:00",
    //     "nextDueIn": "2025-08-03T00:00:00",
    //     "lastDonePort": "Visakhapatnam",
    //     "lastDoneCountry": "India",
    //     "lastDoneServiceProvider": "Marine Mechanics",
    //     "attachmentName": "VSL.GCL MAHANADI- 15 PPM MONITOR.pdf",
    //     "attachmentGuid": "b32e9670f7f34894922c68c1277d7204",
    //     "remarks": "Certificate Upload by Rubini.",
    //     "modifiedBy": null,
    //     "isOverDue": false,
    //     "hasServiceImages": false,
    //     "isApproved": true,
    //     "status": "Approved",
    //     "totalEquipmentQty": 0,
    //     "servicedQty": 0
    // }

    if (attachmentDetail) {
      prevState.serviceUpdate.attachmentName = attachmentDetail.FileName;
      prevState.serviceUpdate.attachmentGuid = attachmentDetail.Guid;
      prevState.docfile = "";
    }
    if (serviceAttachment) {
      prevState.serviceUpdate.attachService = serviceAttachment;
    }
    if (serviceDetail && prevState.serviceUpdate.shipId == 0) {
      prevState.serviceUpdate.serviceTypeId = serviceDetail.serviceTypeId;
      prevState.serviceUpdate.shipEquipmentId = serviceDetail.shipEquipmentId;
      prevState.serviceUpdate.equipmentServiceId =
        serviceDetail.equipmentServiceId;
      prevState.serviceUpdate.previousEquipmentServiceId =
        serviceDetail.previousEquipmentServiceId;
      prevState.serviceUpdate.portId = serviceDetail.portId;
      prevState.serviceUpdate.shipId = serviceDetail.shipId;
      prevState.serviceUpdate.serviceProviderId =
        serviceDetail.serviceProviderId;
      prevState.serviceUpdate.serviceType = serviceDetail.serviceType;
      prevState.serviceUpdate.serviceDate = serviceDetail.serviceDate;
      prevState.serviceUpdate.nextDueIn = serviceDetail.nextDueIn;
      prevState.serviceUpdate.lastDonePort = serviceDetail.lastDonePort;
      prevState.serviceUpdate.lastDoneCountry = serviceDetail.lastDoneCountry;
      prevState.serviceUpdate.serviceProviderId =
        serviceDetail.serviceProviderId;
      prevState.serviceUpdate.lastDoneServiceProvider =
        serviceDetail.lastDoneServiceProvider;
      prevState.serviceUpdate.serviceDate = serviceDetail.serviceDate;
      prevState.serviceUpdate.isOverDue = serviceDetail.isOverDue;
      prevState.serviceUpdate.totalEquipmentQty =
        serviceDetail.totalEquipmentQty;
      prevState.serviceUpdate.zoneId = serviceDetail?.zoneId;
    }
    if (serviceDetail && ServiceDate) {
      prevState.serviceUpdate.serviceDate = ServiceDate.serviceDate;
      prevState.serviceUpdate.nextDueIn = ServiceDate.nextDueDate;
      /*    prevState.SelectedServiceYear = ServiceDate.SeriveYear.map((r) => {
        return r.shipName;
      }); */
      prevState.isApproved = serviceDetail.isApproved;
      dispatch({
        type: "getServiceDateSuccess",
        data: "",
      });
    }
    // if (serviceDetail && prevState.serviceUpdate.remarks === "") {
    //   prevState.serviceUpdate.remarks = serviceDetail.remarks;
    // }
  }
  getResetServiceUpdate = () => {
    const updatedServiceUpdate = {
      ...this.state.serviceUpdate,
      lastDonePort: null,
      lastDoneCountry: null,
      lastDoneServiceProvider: null,
      portId: null,
    };

    return updatedServiceUpdate;
  };
  verify() {
    const { t } = this.props;
    let flag = true;
    if (
      this.state.serviceUpdate.servicedQty === "" ||
      isNaN(this.state.serviceUpdate.servicedQty) ||
      this.state.serviceUpdate.lastDoneServiceProvider == "" ||
      this.state.serviceUpdate.lastDoneCountry == "" ||
      this.state.serviceUpdate.lastDonePort == "" ||
      (this.props.EquipmentServiceUpdateType?.toLowerCase() != "ship staff" &&
        (this.state.serviceUpdate.zoneId == null ||
          this.state.serviceUpdate.zoneId == 0 ||
          this.state.serviceUpdate.zoneId == ""))
    ) {
      flag = false;
      if (
        this.state.serviceUpdate.servicedQty == "" ||
        isNaN(this.state.serviceUpdate.servicedQty)
      ) {
        $("#servicedQantityErr").text(t("ErrorMessage.RequiredMsg"));
      } else {
        $("#servicedQantityErr").text("");
      }
      if (this.state.serviceUpdate.lastDoneServiceProvider == "") {
        $("#lastDoneServiceProviderErr").text(t("ErrorMessage.RequiredMsg"));
      } else {
        $("#lastDoneServiceProviderErr").text("");
      }
      if (this.state.serviceUpdate.lastDoneCountry == "") {
        $("#lastDoneCountryErr").text(t("ErrorMessage.RequiredMsg"));
      } else {
        $("#lastDoneCountryErr").text("");
      }
      if (
        this.props.EquipmentServiceUpdateType?.toLowerCase() != "ship staff"
      ) {
        if (
          this.state.serviceUpdate.zoneId == null ||
          this.state.serviceUpdate.zoneId == 0 ||
          this.state.serviceUpdate.zoneId == ""
        ) {
          $("#zoneIdError").text(t("ErrorMessage.RequiredMsg"));
        } else {
          $("#zoneIdError").text("");
        }
      }
      if (this.state.serviceUpdate.lastDonePort == "") {
        $("#lastDonePortErr").text(t("ErrorMessage.RequiredMsg"));
      } else {
        $("#lastDonePortErr").text("");
      }
    }

    return flag;
  }

  getResetServiceUpdate = () => {
    const updatedServiceUpdate = {
      ...this.state.serviceUpdate,
      lastDonePort: null,
      lastDoneCountry: null,
      lastDoneServiceProvider: null,
      portId: null,
    };

    return updatedServiceUpdate;
  };

  UpdateService() {
    const {
      dispatch,
      t,
      PortList,
      EquipmentServiceTypeDetail,
      ServiceDate,
      ServiceProviderPortList,
    } = this.props;
    const validPorts = PortList.data.map((item) => item.port);
    const validCountry = PortList.data.map((item) => item.country);
    const validProvider = ServiceProviderPortList.data.map(
      (item) => item.serviceProvider
    );
    const referenceServiceDate = Moment(
      EquipmentServiceTypeDetail.serviceDate
    ).startOf("day");
    const referenceExpiryDate = Moment(
      EquipmentServiceTypeDetail.nextDueIn
    ).startOf("day");
    const selectedServiceDate = Moment(
      new Date(this.state.serviceUpdate.serviceDate)
    ).startOf("day");
    const selectedExpiryDate = Moment(
      new Date(this.state.serviceUpdate.nextDueIn)
    ).startOf("day");

    console.log(validProvider, "checkvalidprovider", PortList.data, "port");
    console.log(ServiceProviderPortList.data, "lll");
    if (this.verify()) {
      $("#lastDoneServiceProviderErr").text("");
      $("#lastDoneCountryErr").text("");
      $("#zoneIdError").text("");
      $("#lastDonePortErr").text("");
      $("#servicedQantityErr").text("");

      if (
        this.state.serviceUpdate.servicedQty <=
        EquipmentServiceTypeDetail.totalEquipmentQty
      ) {
        if (
          validProvider.includes(
            this.state.serviceUpdate.lastDoneServiceProvider
          )
        ) {
          // $("#lastDoneServiceProviderErr").text("")
          if (validCountry.includes(this.state.serviceUpdate.lastDoneCountry)) {
            // $("#lastDoneCountryErr").text("")
            if (validPorts.includes(this.state.serviceUpdate.lastDonePort)) {
              // $("#lastDonePortErr").text("")

              // $("#servicedQantityErr").text("")
              if (selectedServiceDate.isAfter(referenceServiceDate, "day")) {
                if (selectedExpiryDate.isAfter(referenceExpiryDate, "day")) {
                  if (this.state.FileUploadstatus === true) {
                    //console.log("say",this.state.UpdateService.attachService)
                    this.state.serviceUpdate.modifiedBy = currentuser.email;
                    this.state.serviceUpdate.requestedBy = currentuser.email;
                    if (userroles === Role.mmpladmin) {
                      this.state.serviceUpdate.isAdmin = true;
                    } else {
                      this.state.serviceUpdate.isAdmin = false;
                    }
                    this.setState({});
                    if (this.state.serviceUpdate.serviceDate !== "") {
                      var serviceDate = Moment(
                        new Date(this.state.serviceUpdate.serviceDate)
                      ).format("YYYY-MM-DD");
                      let url1 = `${API.ServiceDateExist}?shipEquipmentId=${this.state.serviceUpdate.shipEquipmentId}&serviceTypeId=${this.state.serviceUpdate.serviceTypeId}&serviceDate=${serviceDate}`;

                      axios
                        .get(url1)
                        .then((response) => {
                          if (response.data === true) {
                            if (
                              this.state.serviceUpdate.attachService &&
                              this.state.serviceUpdate.attachService?.length !==
                                0
                            ) {
                              let value = this.state.serviceUpdate.attachService
                                ? this.state.serviceUpdate.attachService
                                : [];
                              value.map((i) => {
                                i.attachmentName = i.FileName;
                                i.attachmentGuid = i.Guid;
                                i.createdBy = currentuser.name;
                                i.equipmentServiceId =
                                  this.state.serviceUpdate
                                    .previousEquipmentServiceId !== 0
                                    ? this.state.serviceUpdate
                                        .previousEquipmentServiceId
                                    : this.state.serviceUpdate
                                        .equipmentServiceId;
                                return i;
                              });
                              dispatch(
                                postUpdateServiceImages(
                                  this.state.serviceUpdate.attachService,
                                  this.state.serviceUpdate.shipEquipmentId
                                )
                              );
                            }
                            console.log(
                              "imagelength",
                              this.state.serviceUpdate.attachService?.length
                            );
                            // dispatch(putUpdateService(this.state.serviceUpdate, this.state.serviceUpdate.shipEquipmentId)).then((res) => {
                            //   if (fileDatas.length > 0) {
                            //     this.props.dispatch(deleteAttachmentInBucket(fileDatas));
                            //     fileDatas = [];
                            //   }
                            // });
                            let urlput = `${API.PutServiceUpdate}`;
                            const shipstaffupd = this.getResetServiceUpdate();
                            axios
                              .put(
                                urlput,
                                this.props.EquipmentServiceUpdateType?.toLowerCase() ==
                                  "ship staff"
                                  ? shipstaffupd
                                  : this.state.serviceUpdate
                              )
                              .then((response) => {
                                if (response.status === 200) {
                                  dispatch(
                                    getEquipmentServiceTypeList(
                                      this.state.serviceUpdate.shipEquipmentId
                                    )
                                  );
                                  dispatch({
                                    type: "PutServiceUpdateSuccess",
                                    data: response.data,
                                  });
                                  dispatch({
                                    type: "AttchmentUploaded",
                                    data: "",
                                  });
                                  toast.success(t("CommonText.CommonUpdate"), {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                  });
                                }
                                if (fileDatas.length > 0) {
                                  this.props.dispatch(
                                    deleteAttachmentInBucket(fileDatas)
                                  );
                                  fileDatas = [];
                                }
                              })
                              .catch((error) => {
                                dispatch({
                                  type: "PutServiceUpdateFailure",
                                  error: "ERROR",
                                });
                              });
                          } else {
                            // swal("Error!", "The service is already updated for this date. Please choose another date.", "warning");
                            swal({
                              title: t("SwalError.ErrorTitle"),
                              text: t("SwalError.ServiceChose"),
                              icon: "warning",
                              buttons: {
                                confirm: {
                                  text: t("confirmAlertMessage.Ok"),
                                },
                              },
                            });
                          }
                          dispatch({
                            type: "ExistservicedateSuccess",
                            data: response.data,
                          });
                        })
                        .catch((error) => {
                          dispatch({
                            type: "ExistservicedateFailure",
                            error: "ERROR",
                          });
                        });
                    }
                  } else {
                    // swal(
                    //   "Error!", "Please upload the service report.", "warning");
                    swal({
                      title: t("SwalError.ErrorTitle"),
                      text: t("SwalError.ServiceReport"),
                      icon: "warning",
                      buttons: {
                        confirm: {
                          text: t("confirmAlertMessage.Ok"),
                        },
                      },
                    });
                  }
                } else {
                  swal({
                    title: t("SwalError.ErrorTitle"),
                    text: t("SwalError.SelectValidDate"),
                    icon: "warning",
                    buttons: {
                      confirm: {
                        text: t("confirmAlertMessage.Ok"),
                      },
                    },
                  });
                }
              } else {
                swal({
                  title: t("SwalError.ErrorTitle"),
                  text: t("SwalError.ServiceDateSame"),
                  icon: "warning",
                  buttons: {
                    confirm: {
                      text: t("confirmAlertMessage.Ok"),
                    },
                  },
                });
              }
              // dispatch(getEquipmentServiceTypeList(this.state.serviceUpdate.shipEquipmentId));
              // this.clearDetails();
            } else {
              $("#lastDonePortErr").text(t("ServiceUpdateErr.PleasePort"));
            }
          } else {
            $("#lastDoneCountryErr").text(t("ServiceUpdateErr.PleaseCountry"));
          }
        } else {
          $("#lastDoneServiceProviderErr").text(
            t("ServiceUpdateErr.PleaseServiceprovider")
          );
        }
      } else {
        $("#servicedQantityErr").text(t("ServiceUpdateErr.ServiceQtyGreater"));
      }
    }
  }
  /* else {
    if (EquipmentServiceUpdateList.length !== 0) {
      this.ChooseOverdueService();
    } else {
      if (this.state.FileUploadstatus === true) {
        const { dispatch } = this.props;
        //console.log("say",this.state.UpdateService.attachService)
        this.state.serviceUpdate.modifiedBy = currentuser.email;
        if (this.state.SelectedOverdueServiceYear.length !== 0) {
          this.state.serviceUpdate.applicableServiceYear =
            this.state.SelectedOverdueServiceYear.toString();
        } else {
          this.state.serviceUpdate.applicableServiceYear = "";
        }
        this.state.serviceUpdate.requestedBy = currentuser.email;
        if (userroles === Role.mmpladmin) {
          this.state.serviceUpdate.isAdmin = true;
        } else {
          this.state.serviceUpdate.isAdmin = false;
        }
        this.setState({});
        if (
          this.state.serviceUpdate.attachService &&
          this.state.serviceUpdate.attachService?.length !== 0
        ) {
          let value = this.state.serviceUpdate.attachService
            ? this.state.serviceUpdate.attachService
            : [];
          value.map((i) => {
            i.attachmentName = i.FileName;
            i.attachmentGuid = i.Guid;
            i.createdBy = currentuser.name;
            i.equipmentServiceId =
              this.state.serviceUpdate.previousEquipmentServiceId !== 0
                ? this.state.serviceUpdate.previousEquipmentServiceId
                : this.state.serviceUpdate.equipmentServiceId;
            return i;
          });
          dispatch(
            postUpdateServiceImages(
              this.state.serviceUpdate.attachService,
              this.state.serviceUpdate.shipEquipmentId
            )
          );
        }
        console.log(
          "imagelength",
          this.state.serviceUpdate.attachService?.length
        );
        dispatch(
          putUpdateService(
            this.state.serviceUpdate,
            this.state.serviceUpdate.shipEquipmentId
          )
        );
        // dispatch(getEquipmentServiceTypeList(this.state.serviceUpdate.shipEquipmentId));
        // this.clearDetails();
      }
    }
  } */

  /*  ChooseOverdueService = () => {
    this.setState({ openAlert: true });
    confirmAlert({
      message:
        "Do you want to add this service details for any other service year?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            this.setState({ OverDueService: true });
            this.setState({ openAlert: false });
            $("#OverDueService").removeClass("lifeBoat-hide");
          },
        },
        {
          label: "No",
          onClick: () => {
            this.setState({ openAlert: false });
            if (this.state.FileUploadstatus === true) {
              const { dispatch } = this.props;
              //console.log("say",this.state.UpdateService.attachService)
              this.state.serviceUpdate.modifiedBy = currentuser.email;
              if (this.state.SelectedOverdueServiceYear.length !== 0) {
                this.state.serviceUpdate.applicableServiceYear =
                  this.state.SelectedOverdueServiceYear.toString();
              } else {
                this.state.serviceUpdate.applicableServiceYear = "";
              }
              this.state.serviceUpdate.requestedBy = currentuser.email;
              if (userroles === Role.mmpladmin) {
                this.state.serviceUpdate.isAdmin = true;
              } else {
                this.state.serviceUpdate.isAdmin = false;
              }
              this.setState({});
              if (
                this.state.serviceUpdate.attachService &&
                this.state.serviceUpdate.attachService?.length !== 0
              ) {
                let value = this.state.serviceUpdate.attachService
                  ? this.state.serviceUpdate.attachService
                  : [];
                value.map((i) => {
                  i.attachmentName = i.FileName;
                  i.attachmentGuid = i.Guid;
                  i.createdBy = currentuser.name;
                  i.equipmentServiceId =
                    this.state.serviceUpdate.previousEquipmentServiceId !== 0
                      ? this.state.serviceUpdate.previousEquipmentServiceId
                      : this.state.serviceUpdate.equipmentServiceId;
                  return i;
                });
                dispatch(
                  postUpdateServiceImages(
                    this.state.serviceUpdate.attachService,
                    this.state.serviceUpdate.shipEquipmentId
                  )
                );
              }
              console.log(
                "imagelength",
                this.state.serviceUpdate.attachService
              );
              dispatch(
                putUpdateService(
                  this.state.serviceUpdate,
                  this.state.serviceUpdate.shipEquipmentId
                )
              );
              // dispatch(getEquipmentServiceTypeList(this.state.serviceUpdate.shipEquipmentId));
              // this.clearDetails();
            }
          },
        },
      ],
      onClickOutside: () => {
        this.setState({ openAlert: false });
      },
    });
  }; */

  handleFromDateChange(date) {
    console.log("ds", this.props.serviceDetail.nextDueDate);
    const { dispatch, serviceDetail } = this.props;
    let date1 = Moment(new Date(Date.parse(date))).format("YYYY-MM-DD");
    this.state.serviceUpdate.serviceDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
    dispatch(getServiceDates(date1, serviceDetail.interval));
  }

  handleNextDue(date) {
    const { dispatch, serviceDetail } = this.props;
    console.log("ds", date);
    let date1 = Moment(new Date(Date.parse(date))).format("YYYY-MM-DD");
    console.log("ds1", date1);
    this.state.serviceUpdate.nextDueIn = date1;
    // this.state.serviceUpdate.nextDueIn = Moment(
    //   new Date(Date.parse(date))
    // ).format("YYYY-MM-DD");
    this.setState({
      NextDue: date,
      nextDueDatePickerIsOpen: false,
    });
    // dispatch(getServiceDates(date1, serviceDetail.interval));
  }

  openFromDatePicker() {
    this.setState({
      nextDueDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openNextDueDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      nextDueDatePickerIsOpen: !this.state.nextDueDatePickerIsOpen,
    });
  }

  handleInputChangePrice = (e, str) => {
    this.setState({
      ...this.state,
      serviceUpdate: {
        ...this.state.serviceUpdate,
        [str]: parseInt(e.target.value),
      },
    });
  };

  handleBlur() {
    this.setState({
      nextDueDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    // if (nodeName === "remarks") {
    //   this.state.remarks = e.target.value
    // } else {
    this.state.serviceUpdate[nodeName] = e.target.value;
    // }
    this.setState({});
  }

  onHandleInputChange(e) {
    const { t } = this.props;
    let nodeName = e.target.name;
    this.state.serviceUpdate[nodeName] = e.target.files[0].name;
    this.state.docfile = e.target.files[0];
    let filename = this.state.docfile.name;
    let _this = this;
    var upload = filename.split(".").pop();
    if (upload.toLowerCase() === "pdf") {
      $("#FileErrMsg").text("");
      let regex = /^[0-9a-zA-Z\s\(\)\.\_\&\$\#\-\']+$/g;
      if (regex.test(filename)) {
        _this.setState({ FileUploadstatus: true });
        this.setState({ serviceUpdate: this.state.serviceUpdate });
        this.props.dispatch(AddAttachment(e.target.files[0]));
      } else {
        // swal(
        //   "Error!",
        //   "Please upload the file without special characters.",
        //   "warning");
        swal({
          title: t("SwalError.ErrorTitle"),
          text: t("SwalError.UploadFile"),
          icon: "warning",
          buttons: {
            confirm: {
              text: t("confirmAlertMessage.Ok"),
            },
          },
        });
        return;
      }
    } else {
      $("#FileErrMsg").text(`${t("ErrorMessage.Onlyptf")}`);
    }
  }

  confirmChooseFile = (e) => {
    const { t } = this.props;
    this.setState({ openAlert: true });
    confirmAlert({
      message: `${t("confirmAlertMessage.FileuploadMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Ok")}`,
          onClick: () => {
            this.state.serviceUpdate.servicePhoto = this.state.serviceUpdate
              .servicePhoto
              ? [...this.state.serviceUpdate.servicePhoto, ...e]
              : [...e];

            this.setState({ openAlert: false });
            this.props.dispatch(
              uploadAttachments(
                this.state.serviceUpdate.servicePhoto,
                this.state.serviceUpdate.equipmentServiceId
              )
            );
          },
        },
        {
          label: `${t("ComplianceandBudgetScreen.Cancel")}`,
          onClick: () => {
            this.setState({ openAlert: false });
          },
        },
      ],

      onClickOutside: () => {
        this.setState({ openAlert: false });
      },
    });
  };
  onHandleInputChange1(e) {
    let nodeName = e.target.name;
    this.confirmChooseFile(e.target.files);
  }

  onRemoveChange(items) {
    var attachments = this.state.serviceUpdate.attachService;

    const itemNames = new Set(items.map((item) => item.name));

    const filteredServiceAttachment = attachments.filter(
      (attachment) => !itemNames.has(attachment.FileName)
    );

    const fileData = filteredServiceAttachment[0];

    //const filteredGuids = new Set(filteredServiceAttachment.map(item => item.Guid));
    //const filteredNames = new Set(filteredServiceAttachment.map(item => item.FileName));

    for (let i = attachments.length - 1; i >= 0; i--) {
      // if (filteredGuids.has(attachments[i].Guid)) {
      if (fileData?.Guid == attachments[i].Guid) {
        attachments.splice(i, 1);
      }
    }

    let obj = {
      filename: fileData?.FileName,
      guid: fileData?.Guid,
    };
    fileDatas.push(obj);
    //this.props.dispatch(deleteAttachmentInBucket(fileData?.Guid,fileData?.FileName));
    // this.props.dispatch(deleteAttachmentInBucket(filteredGuids.values().next().value,filteredNames.values().next().value));

    this.state.serviceUpdate.servicePhoto = items;
    this.setState({});
  }

  onSelectServiceChange(selectedList, selectedItem) {
    this.state.SelectedServiceYear = selectedList;
    this.state.SelectedOverdueServiceYear = selectedList.map(
      (item) => item.range
    );
    this.setState({}, () => {
      console.log(
        "result",
        this.state.SelectedServiceYear,
        this.state.SelectedOverdueServiceYear
      );
    });
  }

  onRemoveServiceChange(selectedList, selectedItem) {
    this.state.SelectedServiceYear = selectedList;
    this.state.SelectedOverdueServiceYear = selectedList.map(
      (item) => item.range
    );
    this.setState({}, () => {
      console.log(
        "result",
        this.state.SelectedServiceYear,
        this.state.SelectedOverdueServiceYear
      );
    });
  }

  hideSidePanel = () => {
    // this.clearDetails();
    fileDatas = [];
    this.props.dispatch({ type: "EquipmentServiceTypeDetail", data: null });
    this.props.dispatch({ type: "EditEquipmentDetails", data: false });
    this.props.dispatch({
      type: "AttchmentUploaded",
      data: "",
    });
  };

  clearDetails(e) {
    if (e === 1) {
      this.setState({ FileUploadstatus: false });
      $("#FileErrMsg").text("");
      //this.props.dispatch(deleteAttachmentInBucket(this.state.serviceUpdate.attachmentGuid,this.state.serviceUpdate.attachmentName));
      let obj = {
        filename: this.state.serviceUpdate.attachmentGuid,
        guid: this.state.serviceUpdate.attachmentName,
      };
      fileDatas.push(obj);
      this.state.serviceUpdate.attachmentName = "";
      this.state.docfile = "";
      this.state.serviceUpdate.attachmentGuid = "";
      this.props.dispatch({
        type: "AttchmentUploaded",
        data: "",
      });
    }
    /*  let clearData = { FileName: "", Guid: "" };
    this.props.dispatch({
      type: "AttchmentUploaded",
      data: clearData,
    }); */
  }
  handleInputChanges(e, field) {
    this.state.serviceUpdate[field] = e.target.value;
    this.setState({});
    let data = {
      port: this.state.serviceUpdate.lastDonePort,
      country: this.state.serviceUpdate.lastDoneCountry,
      serviceProvider: this.state.serviceUpdate.lastDoneServiceProvider,
    };
    if (e.target.value === "" && field === "lastDonePort") {
      this.state.serviceUpdate.lastDonePort = "";
      this.state.serviceUpdate.lastDoneCountry = "";
      this.state.serviceUpdate.lastDoneServiceProvider = "";
      this.setState({});
      let portdata = {
        port: "",
        country: "",
        serviceProvider: "",
      };
      this.props.dispatch(getShipPortAndCountry(portdata));
    } else {
      this.props.dispatch(getShipPortAndCountry(data));
    }
    // this.setState({},()=>{
    //   if()
    // })
  }

  handleSelectChange(value, field, id, fieldId) {
    this.state.serviceUpdate[field] = value;
    this.state.serviceUpdate[fieldId] = id;
    this.setState({});
    let data = {
      port: this.state.serviceUpdate.lastDonePort,
      country: this.state.serviceUpdate.lastDoneCountry,
      serviceProvider: this.state.serviceUpdate.lastDoneServiceProvider,
    };
    if (
      (data?.port ?? "").trim() !== "" &&
      (data?.country ?? "").trim() !== "" &&
      (data?.serviceProvider ?? "").trim() !== ""
    ) {
      console.log(data, "This is select");
      let url = `${
        API.serviceProviderPortAndCountryV2
      }?portName=${encodeURIComponent(
        data.port
      )}&CountryName=${encodeURIComponent(
        data.country
      )}&serviceProvider=${encodeURIComponent(data.serviceProvider)}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data) {
            if (response.data.zoneId) {
              this.state.serviceUpdate.zoneId = response.data.zoneId;
              this.setState({});
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    this.props.dispatch(getShipPortAndCountry(data));
  }
  renderCountryTitle(state, val) {
    return state?.country?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderServiceProviderTitle(state, val) {
    return (
      state?.serviceProvider?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }

  render() {
    const {
      serviceDetail,
      PortList,
      CountryList,
      ServiceProviderPortList,
      EquipmentServiceUpdateList,
      Loading,
      t,
    } = this.props;

    const { isApproved } = serviceDetail;
    const { openAlert } = this.state;
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="full-height pt-3">
            <div className="grey-bg  course-list-page">
              <div className="panel-box  search-filter-box mb-4">
                <button
                  className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                  onClick={() => this.hideSidePanel()}
                >
                  &larr;{t("CommonText.Return")}
                </button>
                <div className="resource-list-auth-date">
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {serviceDetail.equipmentName}
                      </h5>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className="col-lg-12 mt-2">
                          <label className="form-label">
                            {t("ShipDetailsScreen.ServiceDate")}
                          </label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                            style={{
                              zIndex:
                                this.state.fromDatePickerIsOpen && !Loading
                                  ? 999999
                                  : null,
                            }}
                          >
                            <input
                              value={moment(
                                this.state.serviceUpdate.serviceDate
                              ).format("DD MMM YYYY")}
                              type="text"
                              placeholder={t("ShipDetailsScreen.ServiceDate")}
                              className="form-control date-picker"
                              name="toDate"
                              data-date-format="yyyy-mm-dd"
                              disabled={isApproved ? false : true}
                            />
                            {isApproved ? (
                              <>
                                <DatePicker
                                  selected={this.state.SelectedFromDate}
                                  onChange={this.handleFromDateChange}
                                  open={this.state.fromDatePickerIsOpen}
                                  onClickOutside={this.handleBlur}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement="top-end"
                                  className="form-control date-picker w-5 hide-date"
                                />
                                <div className="input-group-btn calendar-icon">
                                  <button
                                    className="btn btn-default"
                                    onClick={this.openFromDatePicker}
                                  >
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-12 mt-2">
                          <label className="form-label">
                            {t("ShipDetailsScreen.NextDue")}
                          </label>
                          <br></br>
                          <div
                            className="input-group add-on date datepicker"
                            data-date-format="yyyy-mm-dd"
                            style={{
                              zIndex:
                                this.state.nextDueDatePickerIsOpen && !Loading
                                  ? 99999
                                  : null,
                            }}
                          >
                            <input
                              type="text"
                              name="nextAnnuallyDueIn"
                              className="form-control"
                              placeholder={t("ShipDetailsScreen.NextDue")}
                              value={moment(
                                this.state.serviceUpdate.nextDueIn
                              ).format("DD MMM YYYY")}
                              disabled={isApproved ? false : true}
                            />
                            {isApproved ? (
                              <>
                                <DatePicker
                                  selected={this.state.NextDue}
                                  onChange={(e) => this.handleNextDue(e)}
                                  open={this.state.nextDueDatePickerIsOpen}
                                  onClickOutside={this.handleBlur}
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  popperPlacement="top-end"
                                  className="form-control date-picker w-5 hide-date"
                                />
                                <div className="input-group-btn calendar-icon">
                                  <button
                                    className="btn btn-default"
                                    onClick={this.openNextDueDatePicker}
                                  >
                                    <i className="fa fa-calendar mt-1"></i>
                                  </button>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12 mt-2">
                          <label className="form-label required">
                            {t("ServiceBudgetHistory.ServicedQty")}
                          </label>
                          <br></br>
                          <div className="input-group">
                            <input
                              type="number"
                              name="nextAnnuallyDueIn"
                              className="form-control"
                              placeholder={t(
                                "ServiceBudgetHistory.ServicedQty"
                              )}
                              value={this.state.serviceUpdate.servicedQty}
                              onChange={(e) =>
                                this.handleInputChangePrice(e, "servicedQty")
                              }
                              disabled={isApproved ? false : true}
                            />
                          </div>
                          <span
                            id="servicedQantityErr"
                            className="spanErrMsg"
                          ></span>
                        </div>
                        {this.props.EquipmentServiceUpdateType?.toLowerCase() ===
                          "adhoc" && (
                          <>
                            <div className="col-lg-12 mt-2">
                              <label className="form-label">
                                {t("ServiceBudgetHistory.VendorPrice")}
                              </label>
                              <br></br>
                              <div className="input-group">
                                <input
                                  type="number"
                                  name="nextAnnuallyDueIn"
                                  className="form-control"
                                  placeholder="Unit Price"
                                  value={this.state.serviceUpdate.vendorPrice}
                                  onChange={(e) =>
                                    this.handleInputChangePrice(
                                      e,
                                      "vendorPrice"
                                    )
                                  }
                                  disabled={isApproved ? false : true}
                                />
                              </div>
                            </div>
                            <div className="col-lg-12 mt-2">
                              <label className="form-label">
                                {t("ServiceBudgetHistory.MMPLAmount")}
                              </label>
                              <br></br>
                              <div className="input-group">
                                <input
                                  type="number"
                                  name="nextAnnuallyDueIn"
                                  className="form-control"
                                  placeholder="Unit Price"
                                  value={this.state.serviceUpdate.mmplPrice}
                                  onChange={(e) =>
                                    this.handleInputChangePrice(e, "mmplPrice")
                                  }
                                  disabled={isApproved ? false : true}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {this.props.EquipmentServiceUpdateType?.toLowerCase() !=
                          "ship staff" && (
                          <div className="col-lg-12 mt-2">
                            {/* <label className="form-label">Service Port</label>
                          <br></br>
                          <input
                            type="text"
                            name="lastDonePort"
                            className="form-control"
                            placeholder="Service Port"
                            value={this.state.serviceUpdate.port}
                            onChange={this.handleInputChange}
                          ></input> */}
                            <div
                              className="autocomplete-wrappers"
                              style={{
                                zIndex: openAlert
                                  ? 99
                                  : this.state.openPort && !Loading
                                  ? 99999
                                  : null,
                              }}
                            >
                              <label className="form-label required">
                                {t("TopPaneContent.Port")}
                              </label>
                              <br></br>
                              <Autocomplete
                                contentEditable={true}
                                open={!Loading ? this.state.openPort : false}
                                onMenuVisibilityChange={(isOpen) => {
                                  this.state.openPort = isOpen;
                                  this.setState({});
                                }}
                                value={
                                  this.state.serviceUpdate.lastDonePort ?? ""
                                }
                                inputProps={{
                                  placeholder: `${t(
                                    "ShipDetailsScreen.ServicePort"
                                  )}`,
                                  disabled: isApproved ? false : true,
                                }}
                                items={PortList.data ?? []}
                                getItemValue={(item) => item.port}
                                shouldItemRender={this.renderPortTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${
                                      isHighlighted ? "selected-items" : ""
                                    }`}
                                  >
                                    {item.port}
                                  </div>
                                )}
                                onChange={(e, field) =>
                                  this.handleInputChanges(e, "lastDonePort")
                                }
                                onSelect={(value, id) =>
                                  this.handleSelectChange(
                                    value,
                                    "lastDonePort",
                                    id.portId,
                                    "portId"
                                  )
                                }
                              />
                              <span
                                id="lastDonePortErr"
                                className="spanErrMsg"
                              ></span>
                            </div>
                          </div>
                        )}
                        {this.props.EquipmentServiceUpdateType?.toLowerCase() !=
                          "ship staff" && (
                          <div className="col-lg-12 mt-2">
                            <div
                              className="autocomplete-wrappers"
                              style={{
                                zIndex: openAlert
                                  ? 99
                                  : this.state.openCountry && !Loading
                                  ? 99999
                                  : null,
                              }}
                            >
                              <label className="form-label required">
                                {t("EquipmentServiceTypes.Country")}
                              </label>
                              <br></br>
                              <Autocomplete
                                contentEditable={true}
                                value={
                                  this.state.serviceUpdate.lastDoneCountry ?? ""
                                }
                                open={!Loading ? this.state.openCountry : false}
                                onMenuVisibilityChange={(isOpen) => {
                                  this.state.openCountry = isOpen;
                                  this.setState({});
                                }}
                                inputProps={{
                                  placeholder: `${t(
                                    "ShipDetailsScreen.ServiceCountry"
                                  )}`,
                                  disabled: isApproved ? false : true,
                                }}
                                items={CountryList.data ?? []}
                                getItemValue={(item) => item.country}
                                shouldItemRender={this.renderCountryTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${
                                      isHighlighted ? "selected-items" : ""
                                    }`}
                                  >
                                    {item.country}
                                  </div>
                                )}
                                onChange={(e, field) =>
                                  this.handleInputChanges(e, "lastDoneCountry")
                                }
                                onSelect={(value) =>
                                  this.handleSelectChange(
                                    value,
                                    "lastDoneCountry"
                                  )
                                }
                              />
                              <span
                                id="lastDoneCountryErr"
                                className="spanErrMsg"
                              ></span>
                            </div>
                          </div>
                        )}

                        {this.props.EquipmentServiceUpdateType?.toLowerCase() !=
                          "ship staff" && (
                          <div className="col-lg-12 mt-2">
                            <div
                              className="autocomplete-wrappers"
                              style={{
                                zIndex: openAlert
                                  ? 99
                                  : this.state.openServiceProvider && !Loading
                                  ? 99999
                                  : null,
                              }}
                            >
                              <label className="form-label required">
                                {t("ShipDetailsScreen.ServiceProvider")}
                              </label>
                              <br></br>
                              <Autocomplete
                                contentEditable={true}
                                value={
                                  this.state.serviceUpdate
                                    .lastDoneServiceProvider ?? ""
                                }
                                open={
                                  !Loading
                                    ? this.state.openServiceProvider
                                    : false
                                }
                                onMenuVisibilityChange={(isOpen) => {
                                  this.state.openServiceProvider = isOpen;
                                  this.setState({});
                                }}
                                inputProps={{
                                  placeholder: `${t(
                                    "ShipDetailsScreen.ServiceProvider"
                                  )}`,
                                  disabled: isApproved ? false : true,
                                }}
                                items={ServiceProviderPortList.data ?? []}
                                getItemValue={(item) => item.serviceProvider}
                                shouldItemRender={this.renderServiceProviderTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${
                                      isHighlighted ? "selected-items" : ""
                                    }`}
                                  >
                                    {item.serviceProvider}
                                  </div>
                                )}
                                onChange={(e, field) =>
                                  this.handleInputChanges(
                                    e,
                                    "lastDoneServiceProvider"
                                  )
                                }
                                onSelect={(value, obj) =>
                                  this.handleSelectChange(
                                    value,
                                    "lastDoneServiceProvider",
                                    obj.serviceProviderId,
                                    "serviceProviderId"
                                  )
                                }
                              />
                              <span
                                id="lastDoneServiceProviderErr"
                                className="spanErrMsg"
                              ></span>
                            </div>
                          </div>
                        )}
                        {this.props.EquipmentServiceUpdateType?.toLowerCase() !=
                          "ship staff" && (
                          <div className="col-lg-12 mt-2">
                            <label className="form-label required">
                              {t("TopPaneContent.Zone")}
                            </label>
                            <br></br>
                            <select
                              className="form-control"
                              name="zoneId"
                              id="contractType"
                              value={this.state.serviceUpdate.zoneId}
                              onChange={(e) =>
                                this.handleInputChangePrice(e, "zoneId")
                              }
                            >
                              <option value="">
                                {t("VendorManagementScreenContent.SelectZone")}
                              </option>
                              {this.state.zoneList?.map((item) => (
                                <option value={item.zoneId}>
                                  {item.zoneName}
                                </option>
                              ))}
                            </select>
                            <span
                              id="zoneIdError"
                              className="spanErrMsg"
                            ></span>
                          </div>
                        )}

                        <div className="col-lg-12 mt-2">
                          <label className="form-label">
                            {t("EquipmentServiceTypes.ServiceReport")}
                          </label>
                          <br></br>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                {t("CommonText.BrowseFile")}
                                <input
                                  type="file"
                                  id="files"
                                  style={{ marginRight: 40 }}
                                  name="attachmentName"
                                  onChange={(e) => this.onHandleInputChange(e)}
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                  disabled={isApproved ? false : true}
                                />
                              </span>
                            </div>
                            <input
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={this.state.serviceUpdate.attachmentName}
                              disabled={isApproved ? false : true}
                            />
                            {this.state.serviceUpdate.attachmentName ? (
                              <div
                                class="input-group-append"
                                style={{ cursor: "pointer" }}
                              >
                                {isApproved ? (
                                  <i
                                    class="fa fa-times input-group-text"
                                    aria-hidden="true"
                                    onClick={() => this.clearDetails(1)}
                                  ></i>
                                ) : (
                                  <></>
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <span id="FileErrMsg" className="spanErrMsg"></span>
                        </div>
                        <div className="col-lg-12 hide-pic-option mt-2">
                          <label className="form-label">
                            {t("ShipDetailsScreen.ServicePhotos")}
                          </label>
                          <br></br>
                          <div
                            class="input-group"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div class="input-group-prepend">
                              <span
                                class="input-group-text"
                                style={{ paddingRight: "10px" }}
                              >
                                {t("CommonText.BrowseFile")}
                                <input
                                  type="file"
                                  id="files"
                                  accept="image/*"
                                  multiple
                                  name="sdocidno"
                                  onChange={(e) => this.onHandleInputChange1(e)}
                                  onClick={(event) => {
                                    event.currentTarget.value = null;
                                  }}
                                  disabled={isApproved ? false : true}
                                  style={{
                                    marginRight: "10px",
                                    display: "inline-block",
                                  }}
                                />
                              </span>
                            </div>
                            {/* <input
                              type="text"
                              class="form-control"
                              placeholder=""
                              value={this.state.serviceUpdate.attachmentName}
                            />
                            <div class="input-group-append">
                              {this.state.serviceUpdate.attachmentName ? (
                                <i
                                  class="fa fa-times input-group-text"
                                  aria-hidden="true"
                                  onClick={() => this.clearDetails()}
                                ></i>
                              ) : (
                                  ""
                                )}
                            </div> */}

                            <div className="mui-select" style={{ flex: 1 }}>
                              <Multiselect
                                isObject={true}
                                showArrow={false}
                                // displayValue={isApproved ? "name" : "fileName"}
                                displayValue="name"
                                emptyRecordMsg=""
                                disable={isApproved ? false : true}
                                style={{
                                  // multiselectContainer: {
                                  //   width: "79%",
                                  //   marginRight: "-8px",
                                  // },
                                  searchBox: {
                                    borderTopLeftRadius: "0px",
                                    borderBottomLeftRadius: "0px",
                                    minHeight: "38px",
                                  },
                                  option: {
                                    "margin-right": 0,
                                    display: "block",
                                    "font-weight": "normal",
                                  },
                                  chips: { "background-color": "#1a3464" },
                                }}
                                // onSelect={(item) => this.onSelectChange(item)}
                                onRemove={(item) => this.onRemoveChange(item)}
                                selectedValues={
                                  // isApproved ?
                                  this.state.serviceUpdate.servicePhoto
                                  // this.state.ServiceImages
                                }
                                placeholder={""}
                                closeIcon="cancel"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12 mt-2">
                          <label className="form-label">
                            {t("DashboardShipReports.Remarks")}
                          </label>
                          <br></br>
                          <textarea
                            type="text"
                            name="remarks"
                            className="form-control"
                            onChange={(e) => this.handleInputChange(e)}
                            value={
                              this.state.serviceUpdate.remarks === null
                                ? ""
                                : this.state.serviceUpdate.remarks
                            }
                            disabled={isApproved ? false : true}
                          ></textarea>
                        </div>
                        {userroles === Role.mmpl ? (
                          <div className="col-lg-12">
                            <label className="form-label">
                              {t("EquipmentServiceTypes.Status")} :{" "}
                            </label>
                            <span>
                              {serviceDetail.status === "Approved" ||
                              serviceDetail.status === "Rejected" ? (
                                <> {serviceDetail.status}</>
                              ) : (
                                <b> {serviceDetail.status}</b>
                              )}
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}
                        {/*  <div className="col-12 mt-2">
                          <div
                            id="OverDueService"
                            className="card mt-2 MM-card-header lifeBoat-hide"
                            style={{
                              backgroundColor: "white",
                              border: "1px solid white",
                            }}
                          >
                            <div className="card-body">
                              <h6
                                className="card-title ml-2 mt-2 px-2"
                                style={{ color: "092a51" }}
                              >
                                Applicable Service
                              </h6>
                            </div>
                            <div className="search-filter-box py-0">
                              <div className="row">
                                <div className="col-lg-12 mt-2">
                                  <label className="form-label">
                                    Applicable Service Year
                                  </label>
                                  <Multiselect
                                    options={EquipmentServiceUpdateList ?? []}
                                    isObject={true}
                                    showArrow={true}
                                    style={{
                                      option: {
                                        marginRight: 0,
                                        display: "block",
                                        fontWeight: "normal",
                                      },
                                      chips: { backgroundColor: "#1a3464" },
                                    }}
                                    onSelect={(item) =>
                                      this.onSelectServiceChange(item)
                                    }
                                    onRemove={(item) =>
                                      this.onRemoveServiceChange(item)
                                    }
                                    selectedValues={
                                      this.state.SelectedServiceYear
                                    }
                                    placeholder={
                                      this.state.SelectedServiceYear &&
                                      this.state.SelectedServiceYear.length
                                        ? ""
                                        : "Select"
                                    }
                                    closeIcon="cancel"
                                    displayValue="finalyear"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>

                      <div className="row">
                        <div className={"col-lg-12 mt-2 mb-2"}>
                          <label className="form-label"></label>
                          <br></br>
                          <div
                            className="form-group search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            {isApproved ? (
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.UpdateService()}
                              >
                                {t("EquipmentServiceTypes.Update")}{" "}
                              </button>
                            ) : (
                              <></>
                            )}
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.hideSidePanel()}
                            >
                              {t("ComplianceandBudgetScreen.Cancel")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  ShowEditScreen = () => {
    this.props.history.push(`/Home/MDEdit/${this.state.id}`);
    this.props.dispatch({ type: "ShowMISidePan", data: false });
    this.props.dispatch({ type: "ShowEURegSidePan", data: false });
    this.props.dispatch({ type: "ShowRDSidePan", data: false });
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  downloadAttachment(fileName, guid) {
    const { dispatch } = this.props;
    let data = {};
    data.attachmentName = fileName;
    data.attachmentGuid = guid;
    dispatch(DownloadAttachment(fileName, guid));
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    serviceUpdate: state.ServiceUpdateReducer.ServiceUpdate || [],
    equipmentDetail: state.ShipEquipmentReducer.EquipmentDetail,
    attachmentDetail: state.SidePanReducer.attachmentDetail,
    PortList: state.MasterScreenReducer.ShipPortList || [],
    EquipmentServiceUpdateList:
      state.ShipEquipmentReducer.EquipmentServiceUpdateList || [],
    CountryList: state.MasterScreenReducer.ShipCountryList || [],
    ServiceProviderPortList:
      state.MasterScreenReducer.ShipServiceProviderPortList || [],
    Loading: state.PageLoaderReducer.loading,
    ServiceDate: state.MasterScreenReducer.ServiceDate,
    // ServiceImages: state.ApproverScreenReducer.ServiceImages || [],
    serviceAttachment: state.MasterScreenReducer.serviceAttachment,
    EquipmentServiceUpdateType:
      state.SidePanReducer.EquipmentServiceUpdateType || "",
    EquipmentServiceTypeDetail: state.SidePanReducer.EquipmentServiceTypeDetail,
  };
}
export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentUpdate)
);
